export default __webpack_public_path__ + "static/media/1.587dfd4e.jpg";